import React, { ChangeEvent } from 'react';
import { Sticky, StickyContainer } from 'react-sticky';

import CategorySelector from 'components/CategorySelector';
import ScrollNav from 'components/ScrollNav';
import MediaLgUp from 'components/Responsive/MediaLgUp';
import MediaMdDown from 'components/Responsive/MediaMdDown';
import MediaSmDown from 'components/Responsive/MediaSmDown';
import InnerTabs from 'components/InnerTabs';
import SearchField from 'components/SearchField';

import Profile from './components/Profile';
import Name from './components/Name';

interface Props {
  activeItem: number | null,
  categories: { name: string }[],
  descriptiveText: string,
  filterString: string,
  qualityGroups: {}[],
  onFilterStringChange: (evt: ChangeEvent<HTMLInputElement>) => void,
  onGoToItem: (item: { id: number, name: string }, options: any) => void,
  stickyMenuItems: {}[],
}

export default function MyselfComponent(props: Props) {
  const {
    activeItem,
    categories,
    descriptiveText,
    filterString,
    onFilterStringChange,
    onGoToItem,
    qualityGroups,
    stickyMenuItems,
  } = props;
  return (
    <div>
      <MediaSmDown>
        <InnerTabs />
      </MediaSmDown>

      <h1 className="heading heading--1 heading--close">
        <Name />
      </h1>
      <p
        className="lede"
        dangerouslySetInnerHTML={{ __html: descriptiveText }}
      />
      <hr />

      <MediaLgUp>
        <StickyContainer style={{ height: 'auto' }} className="row">
          <div className="nav nav--stacked nav--stacked--1-of-4 nav--stacked--roman">
            <Sticky>
              {({ style }) => (
                <ScrollNav
                  style={style}
                  data={stickyMenuItems}
                  gotoItem={onGoToItem}
                  active={activeItem}
                  inverse
                />
              )}
            </Sticky>
          </div>
          <div className="stack-content stack-content--3-of-4">
            <Profile />
            <SearchField onChange={onFilterStringChange} value={filterString} />
            {qualityGroups}
          </div>
        </StickyContainer>
      </MediaLgUp>

      <MediaMdDown>
        <Profile />
        <SearchField onChange={onFilterStringChange} value={filterString} />
        <div style={{ position: 'sticky', top: 0, zIndex: 1 }}>
          <CategorySelector
            data={categories.filter(item => item.name)}
            gotoItem={onGoToItem}
          />
        </div>
        {qualityGroups}
      </MediaMdDown>
    </div>
  );
}
